import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
    CompanyService,
    Contact,
    StudentService,
    TrainingSessionCompany,
} from '../../../../../../_services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommaDotPipe } from '../../../../../_shared/comma-dot.pipe';

@Component({
    selector: 'registration-company-edition',
    templateUrl: 'company-edition.component.html',
    styleUrls: [
        '../../registration.component.scss',
        '../../../../../_shared/label/label.component.scss',
    ],
    providers: [CommaDotPipe],
})
export class SessionCompanyEditionComponent implements OnInit {
    _tsCompany: TrainingSessionCompany;
    @Output() getCompany: EventEmitter<any> = new EventEmitter<any>();
    @Output() getPrice: EventEmitter<string> = new EventEmitter<string>();
    @Output() getType: EventEmitter<any> = new EventEmitter<any>();
    @Output() getCurrency: EventEmitter<any> = new EventEmitter<any>();

    _priceNoCents: string = '';
    priceCurrency: string = 'EURO';
    displayedCurrency: string = '€';

    inputTsCompany: TrainingSessionCompany;

    contacts: Contact[];

    price: number;
    createdCompany: any;
    private addCompanyModal;

    constructor(
        private companyService: CompanyService,
        private modalService: NgbModal
    ) {}

    ngOnInit(): void {}

    @Input()
    set tsCompany(tsCompany: TrainingSessionCompany) {
        this._tsCompany = tsCompany;
        if (tsCompany.price) {
            this.priceNoCents = tsCompany.price / 100 + '';
        } else {
            this.priceNoCents = '0';
        }
    }

    get tsCompany(): TrainingSessionCompany {
        return this._tsCompany;
    }

    set priceNoCents(priceNoCents) {
        this._priceNoCents = priceNoCents;
        this.getPrice.emit(priceNoCents);
    }

    get priceNoCents() {
        return this._priceNoCents;
    }

    searchCompanies(keyword: string) {
        return this.companyService.search(keyword);
    }

    changeCurrency(curr: string) {
        switch (curr) {
            case 'EURO':
                this.priceCurrency = 'EURO';
                this.displayedCurrency = '€';
                break;
            case 'DOLLAR':
                this.priceCurrency = 'DOLLAR';
                this.displayedCurrency = '$';
                break;
            default:
                this.priceCurrency = 'EURO';
                this.displayedCurrency = '€';
                break;
        }
        this.getCurrency.emit(this.priceCurrency);
    }

    changeCompany(newVal) {
        if (
            newVal !== null &&
            typeof newVal !== 'undefined' &&
            newVal.id !== null &&
            typeof newVal.id !== 'undefined'
        ) {
            this.tsCompany = newVal;
        }

        this.getCompany.emit(this.tsCompany);
        this.getCurrency.emit(this.priceCurrency);
    }

    companyListFormatter(data: any): string {
        let html = '';
        html += data.name ? `<span><strong>${data.name}</strong></span>` : '';
        html += data.id ? `<span> (${data.id})</span>` : '';
        html += data.city ? `<span> - ${data.city}</span>` : '';

        return html;
    }

    onChangeType(type) {
        this.getType.emit(type);
    }

    showModalAddCompany(addCompanyModal) {
        event.stopPropagation();
        this.createdCompany = {
            name: '',
            siret: '',
            address1: '',
            address2: '',
            zipCode: '',
            city: '',
            deleted: false,
            initialized: true,
        };
        this.addCompanyModal = this.modalService.open(addCompanyModal, {
            windowClass: 'addCompanyModal',
        });
    }

    getCreatedCompany(event: any) {
        this.changeCompany(event);
        this.inputTsCompany = event;
        this.closeCreateCompanyModal();
    }

    closeCreateCompanyModal() {
        this.addCompanyModal.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-company/company-edition/company-edition.component.ts